import { ComponentAccess } from '../useCurrentAccessPolicy';
import { adminPolicy } from './admin';
import { administrationPolicy } from './administration';
import { nursePolicy } from './nurse';

export { adminPolicy } from './admin';
export { administrationPolicy } from './administration';
export { nursePolicy } from './nurse';


export const POLICY_CONFIGS: Record<string, ComponentAccess> = {
  'administration': administrationPolicy,
  'nurse': nursePolicy,
  'admin': adminPolicy,
};
